import { useRouter } from 'next/router';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Translate, useTranslate } from '~/i18n';
import Button from '../common/button';
import Container from '../common/container';
import cn from 'classnames';

export const TypesFilters = ({
   experiencesCount,
   eventsCount,
}: {
   experiencesCount?: number;
   eventsCount?: number;
}) => {
   const router = useRouter();

   const types = [
      {
         title: <Translate id="filters:showing all" />,
         target: '',
      },
      {
         title: <Translate id="filters:experiences" />,
         count: experiencesCount,
         target: '/experiences',
      },
      {
         title: <Translate id="filters:events" />,
         count: eventsCount,
         target: '/events',
      },
      // {
      //    title: <Translate id="filters:coaches" />,
      //    count: 16,
      //    target: '/coaches',
      // },
   ];
   const { dir } = useTranslate();

   const handleTypeClick = (target: string) => {
      const { query } = router;
      router.push(`/${query.lang}/${query.location || 'all-cities'}${target}`);
   };

   const activeTarget = router.pathname.includes('/[location]/experiences')
      ? '/experiences'
      : router.pathname.includes('/[location]/events')
      ? '/events'
      : router.pathname.includes('/[location]/coaches')
      ? '/coaches'
      : '';

   if (!eventsCount) return <div className="py-6"></div>;

   return (
      <div className="py-3 mt-10 tablet:py-6 tablet:border-b tablet:mt-0">
         <Swiper
            className="block sm:hidden ltr:pl-4 rtl:pr-4"
            dir={dir}
            key={`types-${dir}`}
            freeMode
            spaceBetween={7}
            breakpoints={{
               530: { slidesPerView: 3 },
               0: { slidesPerView: 2.5 },
            }}
            slidesPerView={4}>
            {types.map(({ title, count, target }, index) => (
               <SwiperSlide key={index} className="py-2 px-1.5">
                  <Button
                     onClick={() => handleTypeClick(target)}
                     className={cn(
                        '!rounded-full !py-2.5 w-[170px] !shadow-none text-sm whitespace-nowrap',
                        activeTarget !== target && 'border-opacity-20'
                     )}
                     type="secondary">
                     {title} {count ? `(${count})` : ''}
                  </Button>
               </SwiperSlide>
            ))}
         </Swiper>
         <Container>
            <div className="items-center justify-center hidden space-x-6 rtl:space-x-reverse sm:flex">
               {types.map(({ title, count, target }, index) => (
                  <Button
                     onClick={() => handleTypeClick(target)}
                     className={cn(
                        '!rounded-full !py-2.5 w-[200px] !shadow-none',
                        activeTarget !== target && 'border-opacity-20'
                     )}
                     type="secondary"
                     key={index}>
                     {title} {count ? `(${count})` : ''}
                  </Button>
               ))}
            </div>
         </Container>
      </div>
   );
};
